export const stopClickPropagation = (e: any, callback: any) => {
  e.stopPropagation();
  callback();
}
